import React, { useContext, useState, useEffect } from 'react';
import { AppContext } from '../App';
import { callApi, getInlineLoader, isAlphanumeric, resolveOrientation, formatMoney } from '../Helpers';
import { IoEnterOutline } from 'react-icons/io5';
import TopBar from '../components/TopBar';
import { AiFillDollarCircle, AiOutlineSetting } from 'react-icons/ai';
import { MdOutlinePriceChange, MdOutlinePhonelinkRing, MdOutlineMarkEmailUnread, MdOutlineLogout, MdPerson } from 'react-icons/md';
import { RiLockPasswordLine } from 'react-icons/ri';
import { FaAward } from 'react-icons/fa';


export default function View(props) {
  const appContext = useContext(AppContext);
  const requiredOrientation = "portrait";
  const [ stickyChatRooms, setStickyChatRooms ] = useState([]);
  const [ normalChatRooms, setNormalChatRooms ] = useState([]);
  const [ ready, setReady ] = useState(false);
  const [ loading, setLoading ] = useState(false);


  const init = async () => {
    appContext.changeOrientation(requiredOrientation);
    setReady(true);
  }

  const openView = (a, b) => {
    appContext.navTo({
      item: 'view',
      subItem: a,
      extraItem: b,
    })
  }

  const viewYourProfile = (a, b) => {
    appContext.navTo({
      item: 'view',
      subItem: 'browse_profile',
      extraItem: appContext.userData.id,
    })
  }

  const buyCoins = (a, b) => {
    appContext.navTo({
      item: 'coins_shop',
    })
  }

  const logout = async () => {
    setLoading(true);
    await appContext.deleteLocalUsers();
    await appContext.init().then(async () => {
      setLoading(false);
      appContext.openHome();
    });
  }

  useEffect(() => {
    if(appContext.auth) {
      //initialize
      init();
    } else {
      //take to common area
      appContext.openLogin();
    }
  }, []);

  useEffect(() => {
    if(ready) {
      appContext.setShowOverlayLoader(false);
    }
  }, [ ready ]);

  useEffect(() => {
    appContext.setShowOverlayLoader(loading);
  }, [ loading ]);

  if(ready) {
    return (
      <>
        <TopBar title="Your Account"/>
        <div className="FullPane"  data-support-top-bar={true}>
          <div className="container">
            <div className="row">

              <div className="col-md-6 col-sm-12" style={{ marginTop: "10px" }}>
                <div className="card text-end" style={{ height: "100%" }}>
                  <div className="card-body">
                    <h1>{appContext.userData.points}</h1>
                    <small className="text-muted">Points</small>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-sm-12" style={{ marginTop: "10px" }}>
                <div className="card text-end" style={{ height: "100%" }}>
                  <div className="card-body">
                    <h1 className="text-goldish" >
                      <AiFillDollarCircle/>
                      &nbsp;
                      {formatMoney(appContext.userData.coins)}
                    </h1>
                    <small className="text-muted">Coins</small><br/>
                    <button
                      onClick={buyCoins}
                      className="btn bg-goldish mNoMargin"
                    >
                      Buy More Coins
                    </button>
                  </div>
                </div>
              </div>

              <div className="col-md-12 col-sm-12" style={{ marginTop: "10px" }}>
                <div className="card text-start">
                  <div className="card-body">
                    <h5 className="font-light" style={{ textTransform: "capitalize", marginBottom: "0px" }}>{appContext.userData.username}</h5>
                    <small className="text-muted">Username</small>
                    <hr/>
                    <div className='text-end'>
                      <button
                        className='btn bg-blackish btn-sm'
                        onClick={viewYourProfile}
                      >
                        View Your Profile
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-12 col-sm-12" style={{ marginTop: "10px", paddingBottom: "20px" }}>
                <div className="row">
                  <div className="col-md-2 col-4 text-center" onClick={() => openView('change_password') } style={{ marginTop: "10px", marginBottom: "10px", cursor: "pointer" }}>
                    <RiLockPasswordLine size={50}/>
                    <small className="form-text">Change Password</small>
                  </div>

                  {/*}<div className="col-md-2 col-4 text-center" onClick={() => openView('phone_link') } style={{ marginTop: "10px", marginBottom: "10px", cursor: "pointer" }}>
                    <MdOutlinePhonelinkRing size={50}/>
                    <small className="form-text">Link Phone Number</small>
                  </div>*/}

                  <div className="col-md-2 col-4 text-center" onClick={() => openView('email_link') } style={{ marginTop: "10px", marginBottom: "10px", cursor: "pointer" }}>
                    <MdOutlineMarkEmailUnread size={50}/>
                    <small className="form-text">Link Email Address</small>
                  </div>

                  <div className="col-md-2 col-4 text-center" onClick={() => openView('your_awards')} style={{ marginTop: "10px", marginBottom: "10px", cursor: "pointer" }}>
                    <FaAward size={50}/>
                    <small className="form-text">Your Awards</small>
                  </div>

                  {/*<div className="col-md-2 col-4 text-center" onClick={() => openView('more_settings')} style={{ marginTop: "10px", marginBottom: "10px", cursor: "pointer" }}>
                    <AiOutlineSetting size={50}/>
                    <small className="form-text">App Settings</small>
                  </div>*/}

                  <div className="col-md-2 col-4 text-center" onClick={() => openView('coins_history')} style={{ marginTop: "10px", marginBottom: "10px", cursor: "pointer" }}>
                    <MdOutlinePriceChange size={50}/>
                    <small className="form-text">Coins History</small>
                  </div>

                  <div className="col-md-2 col-4 text-center" onClick={viewYourProfile} style={{ marginTop: "10px", marginBottom: "10px", cursor: "pointer" }}>
                    <MdPerson size={50}/>
                    <small className="form-text">Your Profile</small>
                  </div>

                  <div className="col-md-2 col-4 text-center" onClick={logout} style={{ marginTop: "10px", marginBottom: "10px", cursor: "pointer" }}>
                    <MdOutlineLogout size={50}/>
                    <small className="form-text">Log Out</small>
                  </div>

                  

                </div>
              </div>

            </div>
          </div>
        </div>
      </>
    )
  } else {
    return (
      <div className="FullPane">
        {getInlineLoader()}
      </div>
    )
  }
}
